import FloatingModal from "./FloatingModal";

import styles from "./ErrorPopup.module.css";

const ErrorPopup = ({ message, onClose, actionLabel, onAction }) => {
  if (!message) return null;

  const hasAction = Boolean(actionLabel && onAction);

  return (
    <FloatingModal
      direction="column"
      minHeight={125}
      bottom={250}
      gap={25}
      contentStyle={{ width: 350 }}
    >
      <div className={styles.message} role="alert">
        {message}
      </div>
      {hasAction && (
        <button type="button" className={styles.actionButton} onClick={onAction}>
          {actionLabel}
        </button>
      )}
      <button
        type="button"
        className={
          hasAction
            ? `${styles.closeButton} ${styles.secondaryButton}`
            : styles.closeButton
        }
        onClick={onClose}
      >
        {hasAction ? "Cerrar" : "Ok"}
      </button>
    </FloatingModal>
  );
};

export default ErrorPopup;
